//system
export const API_IP = '/ip';
export const API_FP = '/fp';
export const API_TIME = '/time';

//Auth
export const API_AUTH_LOGIN = '/auth/signin';
export const API_SSO_VERIFY = '/auth/sso-verify';

//Users
export const API_USERS_TOKEN = '/users/token';
export const API_USERS_NEW88_CHECK = '/predictions/many';
export const API_USERS_SHBET_CHECK = '/users/shbet/check';

//Match
export const API_MATCHS = '/matchs';
export const API_MATCHS_DATE = '/matchs/date';
export const API_MATCHS_BY_DATE = '/match/match-date';
export const API_MATCHS_LIST = '/match/list-match';
export const API_MATCHS_RESULT_LIST = '/match/getMatchResultList';

//Prediction
export const API_PREDICTIONS = '/predictions';
export const API_PREDICTIONS_MANY = '/predictions/many';
export const API_PREDICTIONS_GET = '/predictions/get';

//Settings
export const API_SETTINGS = '/settings';

//Banner
export const API_BANNER = '/banner';
//LUONGSONTV
export const API_MATCH_SCHEDULE = 'match-schedule';

//Files
export const API_FILES = '/file';